import {VIEW_IDS} from '@github-ui/issue-url-helper/constants/view-constants'
import {useLocation} from '@github-ui/react-router'

import {repoSidebarLinks} from './repos-issues-sidebar-links'

export function useIssuesSidebarState() {
  const {pathname, search} = useLocation()

  const isOnIssuesPage = /\/issues\/?$/.test(pathname)

  const searchParams = new URLSearchParams(search)
  const currentQuery = isOnIssuesPage ? searchParams.get('q')?.trim() : undefined
  const currentQueryMatch = currentQuery ? repoSidebarLinks.find(link => link.query === currentQuery) : undefined

  const defaultLink = isOnIssuesPage ? repoSidebarLinks.find(link => link.id === VIEW_IDS.repository) : undefined
  const selectedLink = currentQueryMatch?.id ?? defaultLink?.id ?? ''

  return {selectedLink}
}
